import type { RequestInterface } from '~/common/types';
import { Group, GroupRequest } from '~/groups/types';

export class GroupsRequest implements RequestInterface {
  method = 'get';
  path = '/api/v1/groups';
  headers: Record<string, any>;
  params?: Record<string, any>;

  constructor({
    token,
    params,
  }: {
    token: string;
    params?: Record<string, any>;
  }) {
    this.headers = {
      authorization: `Bearer ${token}`,
    };
    if (params) {
      this.params = {
        ...params,
      };
    }
  }
}

export class GetGroupRequest implements RequestInterface {
  method = 'get';
  path: string;
  headers: Record<string, any>;
  params?: Record<string, any>;

  constructor({
    token,
    groupId,
    params,
  }: {
    token: string;
    groupId: string;
    params?: Record<string, any>;
  }) {
    this.path = `/api/v1/groups/${groupId}`;
    this.headers = {
      authorization: `Bearer ${token}`,
    };
    if (params) {
      this.params = {
        ...params,
      };
    }
  }
}

export class UpdateGroupRequest implements RequestInterface {
  method = 'patch';
  path: string;
  headers: Record<string, any>;
  data: Record<string, any>;
  params?: Record<string, any>;

  constructor({
    token,
    groupId,
    group,
    params,
  }: {
    token: string;
    groupId: string;
    group: GroupRequest;
    params?: Record<string, any>;
  }) {
    this.path = `/api/v1/groups/${groupId}`;
    this.headers = {
      authorization: `Bearer ${token}`,
    };
    this.data = {
      ...group,
    };
    if (params) {
      this.params = {
        ...params,
      };
    }
  }
}

export class CreateGroupRequest implements RequestInterface {
  method = 'post';
  path = '/api/v1/groups';
  headers: Record<string, any>;
  data: Record<string, any>;

  constructor({ token, group }: { token: string; group: Group }) {
    this.headers = {
      authorization: `Bearer ${token}`,
    };
    this.data = {
      ...group,
    };
  }
}

export class DeleteGroupRequest implements RequestInterface {
  method = 'delete';
  path: string;
  headers: Record<string, any>;

  constructor({ token, groupId }: { token: string; groupId: string }) {
    this.path = `/api/v1/groups/${groupId}`;
    this.headers = {
      authorization: `Bearer ${token}`,
    };
  }
}
